document.addEventListener("DOMContentLoaded", () => {

  /* ----------------------------------
     Basic Accessibility Fixes
  ---------------------------------- */
  document.querySelectorAll("br, hr").forEach(el => {
    el.setAttribute("aria-hidden", "true");
  });

  const testimonialHeader = document.querySelector("h1.testimonial-header");
  if (testimonialHeader && testimonialHeader.textContent.trim() === "") {
    testimonialHeader.remove();
  }

  /* ----------------------------------
     Image Alt Text Fix
  ---------------------------------- */
  const irrelevantAltPatterns = [
    "untitled", ".jpg", ".jpeg", ".png", ".webp",
    "image", "img", "photo", "picture", "screenshot",
    "file", "pid:", "asset", "upload", "download",
    "placeholder", "default", "no alt", "alt text"
  ];

  document.querySelectorAll("img").forEach(img => {
    const alt = img.getAttribute("alt");
    const isIrrelevant =
      !alt ||
      alt.trim() === "" ||
      irrelevantAltPatterns.some(p => alt.toLowerCase().includes(p));

    if (isIrrelevant) {
      img.setAttribute("alt", "sparitual Branding Product");
    }
  });

  /* ----------------------------------
     Quantity Buttons & Fields
  ---------------------------------- */
  document
    .querySelectorAll('[data-quantity-action="increase"]')
    .forEach(btn => btn.setAttribute("aria-label", "Increase quantity by 1"));

  document
    .querySelectorAll('[data-quantity-action="decrease"]')
    .forEach(btn => btn.setAttribute("aria-label", "Decrease quantity by 1"));

  document
    .querySelectorAll('[data-pf-type="QuantityField"]')
    .forEach(field => field.setAttribute("aria-label", "Quantity"));

  /* ----------------------------------
     Heading Structure Fixes
  ---------------------------------- */
  const replaceWithHeading = (elements, tagName) => {
    elements.forEach(el => {
      const heading = document.createElement(tagName);
      [...el.attributes].forEach(attr =>
        heading.setAttribute(attr.name, attr.value)
      );
      heading.innerHTML = el.innerHTML;
      el.replaceWith(heading);
    });
  };

  replaceWithHeading(
    document.querySelectorAll(
      "span.sc-bOQUxc.quwHz.pf-12_, span.sc-eZKLwX.jcZVJU.pf-12_, span.sc-bOQUxc.quwHz.pf-18_"
    ),
    "h1"
  );

  replaceWithHeading(
    document.querySelectorAll('h3[data-pf-type="ProductTitle"]'),
    "h2"
  );

  /* ----------------------------------
     Sidebar / Accessibility Menu Focus
  ---------------------------------- */
  const accessBtn = document.getElementById("accessmenubt");
  const sidebarMenu = document.getElementById("sidebar-menu");
  const closeBtn = document.getElementById("closemenubt");

  if (sidebarMenu) sidebarMenu.setAttribute("tabindex", "-1");

  accessBtn?.addEventListener("click", () => {
    setTimeout(() => sidebarMenu?.focus(), 500);
  });

  sidebarMenu?.addEventListener("keydown", e => {
    if (e.key === "Escape") {
      setTimeout(() => accessBtn?.focus(), 500);
    }
  });

  closeBtn?.addEventListener("click", () => {
    setTimeout(() => accessBtn?.focus(), 500);
  });

  /* ----------------------------------
     External & Contact Links
  ---------------------------------- */
  const excludedLinks = [
    "https://www.facebook.com/sparitual",
    "https://twitter.com/sparitual",
    "https://instagram.com/sparitualist"
  ];

  const isExternalLink = url => {
    try {
      return new URL(url).hostname !== window.location.hostname;
    } catch {
      return false;
    }
  };

  document.querySelectorAll("a").forEach(link => {
    const href = link.getAttribute("href");
    if (!href) return;

    if (isExternalLink(href) && !excludedLinks.includes(href)) {
      link.setAttribute("target", "_blank");
      const text = link.textContent.trim();
      link.setAttribute("aria-label", `${text}, This link will open in a new tab`);

      const img = link.querySelector("img, svg");
      if (img) {
        const alt = img.getAttribute("alt") || "";
        img.setAttribute(
          "alt",
          alt
            ? `${alt}, This link will open in a new tab`
            : "This link will open in a new tab"
        );
      }
    }

    if (href.startsWith("mailto:")) {
      link.setAttribute("aria-label", `Email Address: ${link.textContent.trim()}`);
    }

    if (href.startsWith("tel:")) {
      link.setAttribute("aria-label", `Phone number: ${link.textContent.trim()}`);
    }
  });

  /* ----------------------------------
     Accessible Search Focus
  ---------------------------------- */
  const searchContainer = document.querySelector("#Search");
  const searchButton = document.querySelector("#search-button");
  const searchCloseButton = document.querySelector("#search-close-bt");

  const returnSearchFocus = () => {
    setTimeout(() => searchButton?.focus(), 500);
  };

  searchContainer?.addEventListener("keydown", e => {
    if (e.key === "Escape") {
      e.preventDefault();
      returnSearchFocus();
    }
  });

  searchCloseButton?.addEventListener("click", returnSearchFocus);

  /* ----------------------------------
     Delayed / Dynamic Content Fixes
  ---------------------------------- */
  setTimeout(() => {
    document
      .querySelectorAll(".pf-media-slider")
      .forEach(el => el.setAttribute("role", "list"));

    document
      .querySelectorAll(".pf-slide-main-media")
      .forEach(el => el.setAttribute("role", "listitem"));

    [
      "compact-cfc2d55c-7f7e-46c5-adf0-d2ac7f481751",
      "compact-a1707e6a-3a72-4714-b5c3-1e18789408d5"
    ].forEach(id => {
      const input = document.getElementById(id);
      if (input) input.setAttribute("aria-label", "product label");
    });

    const addHiddenLabel = (selector, text) => {
      document.querySelectorAll(selector).forEach(el => {
        if (!el.querySelector(".visually-hidden.sr-only")) {
          const span = document.createElement("span");
          span.className = "visually-hidden sr-only";
          span.textContent = text;
          el.prepend(span);
        }
      });
    };

    addHiddenLabel(
      ".ProductMeta__Price, [data-product-type='price']",
      "Sale Price"
    );

    addHiddenLabel(
      '[data-product-type="compare_at_price"]',
      "Original Price"
    );

  }, 1000);

});
